import SedeEntity from "../entities/SedeEntity";

export default interface SedeRepository {
    getAll(): Promise<SedeEntity[]>;
}

export const SedeRepositoryName = "SedeRepository";
